import { useLocation, useNavigate } from 'react-router-dom';

interface BackState {
  from?: string;
  backLabel?: string;
}

function canonicalDestination(value: string): string {
  const url = new URL(value, window.location.origin);
  const params = new URLSearchParams([...url.searchParams.entries()].sort(([a], [b]) => a.localeCompare(b)));
  const search = params.toString();
  return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
}

export default function PageBack({ fallback = '/', label = 'Indietro' }: { fallback?: string; label?: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as BackState | null;

  function goBack() {
    if (state?.from) {
      const current = canonicalDestination(`${location.pathname}${location.search}${location.hash}`);
      if (canonicalDestination(state.from) === current) {
        navigate(fallback, { replace: true });
        return;
      }
      navigate(state.from);
      return;
    }
    const historyIndex = Number(window.history.state?.idx ?? 0);
    if (historyIndex > 0) navigate(-1);
    else navigate(fallback);
  }

  return <button type="button" className="back-link" onClick={goBack}>← {state?.backLabel ?? label}</button>;
}
